<template>
  <div style="position: relative;">
    <el-form ref="PaIndexGroupManageFilter" :model="PaIndexGroupManage" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="薪资组名称" prop="formFilter.indexGroupName">
          <el-input class="filter-item" v-model="PaIndexGroupManage.formFilter.indexGroupName"
                    :clearable="true" placeholder="薪资组名称"
          />
        </el-form-item>
        <el-form-item label="所属部门" prop="formFilter.sysDeptId">
          <el-cascader class="filter-item" v-model="PaIndexGroupManage.formFilter.sysDeptId" :clearable="true" filterable
                     placeholder="所属部门" :loading="PaIndexGroupManage.sysDeptId.impl.loading" :props="{value: 'deptId', label: 'deptName', checkStrictly: true}"
                     @visible-change="PaIndexGroupManage.sysDeptId.impl.onVisibleChange" :options="PaIndexGroupManage.sysDeptId.impl.dropdownList"
                     @change="onSysDeptIdValueChange">
          </el-cascader>
        </el-form-item>
        <el-form-item label="登录账号" prop="formFilter.loginName">
          <el-input class="filter-item" v-model="PaIndexGroupManage.formFilter.loginName"
                    :clearable="true" placeholder="登录账号"
          />
        </el-form-item>
        <el-form-item label="员工姓名" prop="formFilter.showName">
          <el-input class="filter-item" v-model="PaIndexGroupManage.formFilter.showName"
                    :clearable="true" placeholder="员工姓名"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetPaIndexGroupManage">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshPaIndexGroupManage(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-form ref="PaIndexGroupManage" :model="formData" class="full-width-input" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>薪资组列表</span>
              <div class="base-card-operation">
                <el-button @click="onExportClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('PaIndexGroupManage:PaIndexGroupManage:export')">
                  导出
                </el-button>
                <el-button @click="onAddPaIndexGroupClick()" type="primary" :size="defaultFormItemSize"
                           :disabled="!checkPermCodeExist('PaIndexGroupManage:PaIndexGroupManage:AddPaIndexGroup')">
                  添加
                </el-button>
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paIndexGroup" :data="PaIndexGroupManage.PaIndexGroup.impl.dataList" :size="defaultFormItemSize" @sort-change="PaIndexGroupManage.PaIndexGroup.impl.onSortChange"
                          header-cell-class-name="table-header-gray"
                          highlight-current-row @current-change="PaIndexGroupManage.PaIndexGroup.impl.currentRowChange"
                          @row-click="handleRowClick" row-key="id" default-expand-all height="550px"
                >
                  <el-table-column type="selection" width="55px"></el-table-column>
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="PaIndexGroupManage.PaIndexGroup.impl.getTableIndex" />
                  <el-table-column label="名称" prop="name" width="280px">
                  </el-table-column>
                  <el-table-column label="参数" prop="paramVariable">
                  </el-table-column>
                  <el-table-column label="指标值" prop="indexValue">
                  </el-table-column>
                  <el-table-column label="计算公式" prop="evalFormula">
                  </el-table-column>
                  <el-table-column label="排序" prop="sort" sortable="custom">
                  </el-table-column>
                  <el-table-column label="描述" prop="detail">
                  </el-table-column>
                  <el-table-column label="备注" prop="remark">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right" width="100px">
                    <template slot-scope="scope">
                      <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize" v-show="scope.row.pid!==-1"
                                 :disabled="!checkPermCodeExist('PaIndexGroupManage:PaIndexGroupManage:delete')">
                        删除
                      </el-button>
                      <el-button @click.stop="onEditPaIndexGroupClick(scope.row)" type="text" :size="defaultFormItemSize" v-show="scope.row.pid!==-1"
                                 :disabled="!checkPermCodeExist('PaIndexGroupManage:PaIndexGroupManage:EditPaIndexGroup')">
                        编辑
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="12" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>员工列表</span>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="sysUser" :data="PaIndexGroupManage.SysUser.impl.dataList" :size="defaultFormItemSize" @sort-change="PaIndexGroupManage.SysUser.impl.onSortChange"
                          header-cell-class-name="table-header-gray" row-key="id" height="550px"
                >
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="PaIndexGroupManage.SysUser.impl.getTableIndex" />
                  <el-table-column label="登录账号" prop="loginName">
                  </el-table-column>
                  <el-table-column label="姓名" prop="showName">
                  </el-table-column>
                  <el-table-column label="所属部门" prop="deptIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="职位状态" prop="jobStatusDictMap.name">
                  </el-table-column>
                  <el-table-column label="工龄" prop="workYears">
                  </el-table-column>
                  <el-table-column label="薪级" prop="jobLevelIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="职称" prop="jobTitleIdDictMap.name" width="130px">
                  </el-table-column>
                  <el-table-column label="性别" prop="genderDictMap.name">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button @click.stop="onEditUserInfoClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 :disabled="!checkPermCodeExist('PaIndexGroupManage:PaIndexGroupManage:EditUserInfo')">
                        编辑
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList, treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaIndexGroupController, SysUserController, DictionaryController, SysDeptController} from '@/api';
import addPaIndexGroup from '@/views/PaIndex/addPaIndexGroup.vue';
import editPaIndexGroup from '@/views/PaIndex/editPaIndexGroup.vue';

export default {
  name: 'PaIndexGroupManage',
  props: {
    id: {
      default: undefined
    },
    name: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        PaIndexGroup: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        },
        SysUser: {
          attnGroupId: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          isDatasourceInit: false
        }
      },
      PaIndexGroupManage: {
        formFilter: {
          indexGroupName: undefined,
          sysDeptId: undefined,
          loginName: undefined,
          showName: undefined
        },
        formFilterCopy: {
          indexGroupName: undefined,
          sysDeptId: undefined,
          loginName: undefined,
          showName: undefined
        },
        PaIndexGroup: {
          impl: new TableWidget(this.loadPaIndexGroupWidgetData, this.loadPaIndexGroupVerify, false, true, 'sort', 1)
        },
        SysUser: {
          impl: new TableWidget(this.loadSysUserWidgetData, this.loadSysUserVerify, false, false, 'showName', 1)
        },
        sysDeptId: {
          impl: new DropdownWidget(this.loadSysDeptIdDropdownList, true, 'deptId')
        },
        PaIndexGroupDIv: {
          isInit: false
        },
        UserInfoDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (this.selectedRow !== row) {
        this.selectedRow = row;
        this.$refs.paIndexGroup.clearSelection();
      }
      this.$refs.paIndexGroup.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetPaIndexGroupManage () {
      this.$refs.PaIndexGroupManageFilter.resetFields();
      this.refreshPaIndexGroupManage(true);
    },
    /**
     * 绩效指标组数据获取函数，返回Promise
     */
    loadPaIndexGroupWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paIndexGroupDtoFilter: {
          name: this.PaIndexGroupManage.formFilterCopy.indexGroupName,
          type: 'group',
          searchString: this.name
        }
      }
      params.paIndexGroupDtoFilter.type = 'group';
      return new Promise((resolve, reject) => {
        PaIndexGroupController.list(this, params).then(res => {
          resolve({
            dataList: treeDataTranslate(res.data.dataList, 'id', 'pid'),
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.PaIndexGroupManage.PaIndexGroup.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.PaIndexGroupManage.PaIndexGroup.impl.currentRow.id, 'id');
              this.$refs.paIndexGroup.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 绩效指标组数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaIndexGroupVerify () {
      this.PaIndexGroupManage.formFilterCopy.indexGroupName = this.PaIndexGroupManage.formFilter.indexGroupName;
      return true;
    },
    /**
     * 用户管理数据获取函数，返回Promise
     */
    loadSysUserWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        sysUserDtoFilter: {
          loginName: this.PaIndexGroupManage.formFilterCopy.loginName,
          deptTid: this.PaIndexGroupManage.formFilterCopy.sysDeptId,
          showName: this.PaIndexGroupManage.formFilterCopy.showName,
          indexGroupId: (this.PaIndexGroupManage.PaIndexGroup.impl.currentRow || {}).id
        }
      }
      return new Promise((resolve, reject) => {
        SysUserController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 用户管理数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysUserVerify () {
      this.PaIndexGroupManage.formFilterCopy.loginName = this.PaIndexGroupManage.formFilter.loginName;
      this.PaIndexGroupManage.formFilterCopy.sysDeptId = this.PaIndexGroupManage.formFilter.sysDeptId;
      this.PaIndexGroupManage.formFilterCopy.showName = this.PaIndexGroupManage.formFilter.showName;
      return true;
    },
    /**
     * 所属部门下拉数据获取函数
     */
    loadSysDeptIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        SysDeptController.list(this, params).then(res => {
          resolve(res.data.dataList);
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所属部门选中值改变
     */
    onSysDeptIdValueChange (value) {
    },
    /**
     * 更新薪资组列表
     */
    refreshPaIndexGroupDIvWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.PaIndexGroupManage.PaIndexGroup.impl.refreshTable(true, 1);
      } else {
        this.PaIndexGroupManage.PaIndexGroup.impl.refreshTable();
      }
      this.PaIndexGroupManage.PaIndexGroupDIv.isInit = true;
    },
    /**
     * 更新员工列表
     */
    refreshUserInfoDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.PaIndexGroupManage.SysUser.impl.refreshTable(true, 1);
      } else {
        this.PaIndexGroupManage.SysUser.impl.refreshTable();
      }
      this.PaIndexGroupManage.UserInfoDiv.isInit = true;
    },
    /**
     * 更新薪资组管理
     */
    refreshPaIndexGroupManage (reloadData = false) {
      if (reloadData) {
        this.PaIndexGroupManage.PaIndexGroup.impl.refreshTable(true, 1);
      } else {
        this.PaIndexGroupManage.PaIndexGroup.impl.refreshTable();
      }
      if (reloadData) {
        this.PaIndexGroupManage.SysUser.impl.refreshTable(true, 1);
      } else {
        this.PaIndexGroupManage.SysUser.impl.refreshTable();
      }
      if (!this.PaIndexGroupManage.isInit) {
        // 初始化下拉数据
      }
      this.PaIndexGroupManage.isInit = true;
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      if (row.pid === -1) {
        this.$message.error('操作失败!改节点不能删除!');
        return;
      }
      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaIndexGroupController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.PaIndexGroupManage.PaIndexGroup.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditPaIndexGroupClick (row) {
      if (row.pid === -1) {
        this.$message.error('操作失败!改节点不能修改!');
        return;
      }
      let params = {
        id: row.id
      };

      this.$dialog.show('编辑', editPaIndexGroup, {
        area: '1100px', offset: '10px'
      }, params).then(res => {
        this.PaIndexGroupManage.PaIndexGroup.impl.refreshTable();
      }).catch(e => {});
    },
    /**
     * 导出
     */
    onExportClick () {
      let params = {
        paIndexGroupDtoFilter: {
          name: this.PaIndexGroupManage.formFilterCopy.indexGroupName,
          searchString: this.name
        }
      };

      PaIndexGroupController.export(this, params, '绩效指标组.xlsx').then(res => {
        this.$message.success('导出成功');
      }).catch(e => {
        this.$message.error(e.errorMessage);
      });
    },
    /**
     * 添加
     */
    onAddPaIndexGroupClick () {
      let params = {
        pid: 1,
        type: 'group'
      };

      this.$dialog.show('添加', addPaIndexGroup, {
        area: '1100px', offset: '10px'
      }, params).then(res => {
        this.refreshPaIndexGroupDIvWidget();
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditUserInfoClick (row) {
      let params = {
        userId: row.userId
      };

      params.closeVisible = 1;
      this.$router.push({name: 'EditUserInfo', query: params});
    },
    onResume () {
    },
    /**
     * 获取绩效指标组详细信息
     */
    loadPaIndexGroupData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaIndexGroup.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaIndexGroupController.view(this, params).then(res => {
            this.formData.PaIndexGroup = {...res.data, isDatasourceInit: true};
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaIndexGroup: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          indexModelId: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          sysUser: {
          },
          isDatasourceInit: false
        },
        SysUser: {
          attnGroupId: undefined,
          userId: undefined,
          loginName: undefined,
          password: undefined,
          deptId: undefined,
          deptTid: undefined,
          showName: undefined,
          userType: undefined,
          headImageUrl: undefined,
          userStatus: undefined,
          deletedFlag: undefined,
          createUserId: undefined,
          updateUserId: undefined,
          createTime: undefined,
          updateTime: undefined,
          jobLevelFilePath: undefined,
          gender: undefined,
          entryTime: undefined,
          jobStatus: undefined,
          workStatus: undefined,
          regularTime: undefined,
          workYears: undefined,
          birthDate: undefined,
          jobLevelId: undefined,
          jobTitleId: undefined,
          indexGroupId: undefined,
          email: undefined,
          mobilePhone: undefined,
          landlinePhone: undefined,
          emContact1: undefined,
          emContact1Tel: undefined,
          emContact2: undefined,
          emContact2Tel: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshPaIndexGroupManage();
    }
  },
  computed: {
    getTabPaneHeight () {
      return (this.getMainContextHeight - 102);
    },
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    this.formInit();
  },
  watch: {
    // 绩效指标组选择行数据变化
    'PaIndexGroupManage.PaIndexGroup.impl.currentRow': {
      handler (newValue) {
        this.PaIndexGroupManage.SysUser.impl.refreshTable(true, 1);
      },
      immediate: true
    }
  }
}
</script>
